module.exports = __webpack_public_path__ + "static/records-list-0af5156b545a8746e39c85c404b895f2.png";